import * as yup from 'yup';
import { MAX_10_CHARS, INVALID_DATE_MESSAGE, WORKER_ID_REGEX } from '@/lib/validations';

const ALL_OR_NONE_MESSAGE = 'All three fields must be provided or all must be cleared';

export const workdayValidationSchema = yup.object().shape({
  workerId: yup
    .string()
    .matches(WORKER_ID_REGEX, { excludeEmptyString: true, message: 'Worker ID must be a 32-character hex string' })
    .when(['workdayId', 'workdayHireDate'], {
      is: (workdayId, workdayHireDate) => workdayId || workdayHireDate,
      then: (schema) => schema.required(ALL_OR_NONE_MESSAGE),
    }),
  workdayId: yup
    .string()
    .max(10, MAX_10_CHARS)
    .when(['workerId', 'workdayHireDate'], {
      is: (workerId, workdayHireDate) => workerId || workdayHireDate,
      then: (schema) => schema.required(ALL_OR_NONE_MESSAGE),
    }),
  workdayHireDate: yup
    .date()
    .transform((value) => (value instanceof Date && !isNaN(value) ? value : null))
    .nullable()
    .typeError(INVALID_DATE_MESSAGE)
    .when(['workerId', 'workdayId'], {
      is: (workerId, workdayId) => workerId || workdayId,
      then: (schema) => schema.required(ALL_OR_NONE_MESSAGE),
    }),
}, [
  ['workerId', 'workdayId'],
  ['workerId', 'workdayHireDate'],
  ['workdayId', 'workdayHireDate'],
]);
